import api from './api';
import { API_ENDPOINTS } from '../config/api-endpoints';

export interface WarrantyClaim {
  id: string;
  claimNumber: string;
  planId: string;
  assetId?: string;
  title: string;
  description?: string;
  incidentDate: string;
  status: 'submitted' | 'under_review' | 'approved' | 'rejected' | 'resolved';
  resolutionNote?: string;
  createdAt: string;
  updatedAt: string;
  // Included by getAllClaims / fileClaimForAsset
  asset?: {
    id: string;
    name: string;
    brand?: string;
    category?: string;
    imageUrl?: string;
    productImageUrl?: string;
    model?: string;
    location?: string;
  } | null;
  plan?: {
    id: string;
    planName: string;
    provider: string;
    coverageType: string;
    startDate: string;
    endDate: string;
  } | null;
}

export interface FileClaimDto {
  assetId?: string;
  title: string;
  description?: string;
  incidentDate: string;
}

export const getAllClaims = async (homeId?: string): Promise<WarrantyClaim[]> => {
  const url = homeId
    ? `${API_ENDPOINTS.WARRANTY.GET_ALL_USER_CLAIMS}?homeId=${homeId}`
    : API_ENDPOINTS.WARRANTY.GET_ALL_USER_CLAIMS;
  return await api.get<WarrantyClaim[]>(url);
};

export const fileClaim = async (planId: string, dto: FileClaimDto): Promise<WarrantyClaim> => {
  return await api.post<WarrantyClaim>(API_ENDPOINTS.WARRANTY.FILE_CLAIM(planId), dto);
};

export interface FileClaimForAssetDto {
  homeId: string;
  assetId: string;
  title: string;
  description?: string;
  incidentDate: string;
}

export const fileClaimForAsset = async (dto: FileClaimForAssetDto): Promise<WarrantyClaim> => {
  return await api.post<WarrantyClaim>('/v1/warranty/claim-for-asset', dto);
};

export const getClaimsForPlan = async (planId: string): Promise<WarrantyClaim[]> => {
  return await api.get<WarrantyClaim[]>(API_ENDPOINTS.WARRANTY.GET_CLAIMS(planId));
};
